import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";

// img
import d1 from "../../../../Assets/images/doc.png";
import u1 from "../../../../Assets/images/user.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getAgenciesById,
  getAgencyView,
} from "../../../../store/agency/actions";
import Table from "../../../../components/Common/Table";
import TableProfile from "../../../../components/Common/TableProfile";
import Slider from "react-slick";
import moment from "moment";
import { CstmPagination } from "../../../../components/Common/Common";
import CustomPagination from "../../../../components/Common/CustomPagination";

const AgencyDetail = () => {
  // const [total, SetTotal] = useState(0);
  // const [loader, setLoader] = useState(false);

  // const [body, setBody] = useState({
  //   page: 1,
  //   limit: 10,
  //   orderBy: "createdAt",
  //   order: -1,
  //   search: "",
  // });
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
  };
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => <p className={` m-0`}>{key + 1}</p>,
    },
    {
      label: "Driver Name",
      id: "name",

      isComponent: true,
      component: (item, key, data) => {
        return <TableProfile imageSrc={u1} name={item.name} />;
      },
    },
    {
      label: "Email Id",
      id: "email",
      classNames: "fw-sbold",
    },
    {
      label: "Phone No",
      id: "phonenumber",
      isComponent: true,
      component: (item, key, data) => {
        return <p>{item?.countryCode + item?.phonenumber}</p>;
      },
    },

    {
      label: "Status",
      id: "",
      isComponent: true,
      component: (item) => (
        <Form.Check
          type="switch"
          id="custom-switch"
          checked={item.status == "active" ? true : false}
          // onClick={() => blockUnBlockHandler(item)}
        />
      ),
    },
    {
      label: "Online status",
      id: "OnlineStatus",
    },
    {
      label: "View",
      id: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn">
          <Link
            to={`/manage-driver/registered-driver/view/${item._id}`}
            className="border-0 p-0"
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 25 17"
              fill="none"
            >
              <path
                d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                fill="#666666"
              />
            </svg>
          </Link>
        </div>
      ),
    },
  ];
  const column = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => <p className={` m-0`}>{key + 1}</p>,
    },
    {
      label: "Booking Id",
      id: "bookingNumber",
    },
    {
      label: "Customer Name",
      id: "customerName",
      classNames: "themeBlue m-0 fw-sbold",
    },
    {
      label: "Driver Name",
      id: "driverName",
      classNames: "themeBlue m-0 fw-sbold",
    },
    {
      label: "Total Amount",
      id: "totalAmount",
      isComponent: true,
      component: (item, key) => (
        <p
          className={`${
            item.status === "completed" ? "text-success" : "text-primary"
          } m-0 fw-sbold`}
        >
          ${item?.totalAmount}
        </p>
      ),
    },
    // { label: "Payment Method", id: "paymentMethod" },
    // { label: "Driver or Agency Earning", id: "driverOrAgencyEarning" },
    // { label: "Admin Earning", id: "adminEarning" },
    {
      label: "Status",
      id: "",
      isComponent: true,
      component: (item, key) => (
        <p
          className={`${
            item.status === "completed" ? "text-success" : "text-primary"
          } m-0 fw-sbold`}
        >
          {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
        </p>
      ),
    },
    {
      label: "Created at",
      id: "bookingCreatedAt",
      isComponent: true,
      component: (item) => (
        <p className={` m-0`}>
          {moment(item.bookingCreatedAt).format("MM-DD-YYYY , HH:mm A")}
        </p>
      ),
    },
    // {
    //   label: "Completed at",
    //   id: "bookingCompletedAt",
    //   isComponent: true,
    //   component: (item) => (
    //     <p className={` m-0`}>
    //       {moment(item.bookingCompletedAt).format("MM-DD-YYYY , HH:mm")}
    //     </p>
    //   ),
    // },
    {
      label: "Actions",
      id: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn">
          <Link
            // to={`/agency-booking/detail/${item._id}`}
            to={`/manage-booking/detail/${item._id}`}
            className="border-0 p-0"
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 25 17"
              fill="none"
            >
              <path
                d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                fill="#666666"
              />
            </svg>
          </Link>
        </div>
      ),
    },
  ];

  const { id } = useParams();

  const agencyDetail = useSelector((s) => s.agency.agencyDataById);
  console.log(agencyDetail, "agencyDetails");
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(getAgencyView(id));
    }
  }, []);

  // const [currentPage, setCurrentPage] = useState(1);
  // const reviewsPerPage = 1;
  // const [currentPageGiven, setCurrentPageGiven] = useState(1);

  // // Calculate the index of the first and last review on the current page of receive review
  // const indexOfLastReview = currentPage * reviewsPerPage;
  // const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  // const currentReviews =
  //   agencyDetail.reviewsReceived?.slice(
  //     indexOfFirstReview,
  //     indexOfLastReview
  //   ) || [];
  // // Calculate the index of the first and last review on the current page given
  // const indexOfLastGivenReview = currentPageGiven * reviewsPerPage;
  // const indexOfFirstGivenReview = indexOfLastGivenReview - reviewsPerPage;
  // const currentGievnReviews =
  //   agencyDetail.reviewsGiven?.slice(
  //     indexOfFirstGivenReview,
  //     indexOfLastGivenReview
  //   ) || [];
  // const handlePageChange = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  return (
    <>
      <section className="AgencyDetail py-3 position-relative">
        <Container>
          <Row className="justify-content-start">
            <Col lg="12" className="my-2">
              <Link to="/manage-agency/registered-agency" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>
            <Col lg="12" className="my-2">
              <Row>
                <Col lg="6" className="my-2">
                  <h5 className="m-0 pb-2 fw-sbold themeBlue">
                    Total Earnings
                  </h5>
                  <div
                    className="cardCcstm d-flex align-items-center flex-auto justify-content-around border rounded p-3 gap-10"
                    style={{ minHeight: 135 }}
                  >
                    <div className="content">
                      <h4 className="m-0 themeBlue fw-bold">
                        ${agencyDetail?.totalEarning?.toString() || "0"}
                      </h4>
                    </div>
                    <div className="imgWrp">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="80"
                        height="68"
                        viewBox="0 0 80 68"
                        fill="none"
                      >
                        <path
                          d="M79.9978 43.3855L79.9728 52.6727C79.9728 52.9352 79.7978 53.1852 79.4603 53.3852L54.8235 67.6973C54.136 68.0973 53.0235 68.0973 52.3486 67.6973L30.2992 54.9602L22.3494 50.3728L0.524986 37.7857C0.187495 37.5857 0 37.3232 0 37.0607L0.0249993 27.7734C0.0249993 28.0359 0.199995 28.2859 0.549985 28.4984L22.3494 41.0856L30.2992 45.6729L52.3736 58.4101C53.061 58.8101 54.1735 58.8101 54.8485 58.4101L79.4853 44.098C79.8228 43.898 79.9978 43.648 79.9978 43.3855Z"
                          fill="#7CA444"
                        />
                        <path
                          d="M79.4858 44.0982L54.849 58.4103C54.1615 58.8102 53.0491 58.8102 52.3741 58.4103L30.3747 45.7106L22.4499 41.1357L0.550485 28.4986C-0.149496 28.0986 -0.149497 27.4611 0.537985 27.0611L25.1748 12.7365C25.8623 12.3365 26.9748 12.3365 27.6498 12.7365L49.6367 25.4362L57.5614 30.011L79.4608 42.6607C80.1733 43.0607 80.1733 43.6982 79.4858 44.0982Z"
                          fill="#8ABA55"
                        />
                        <path
                          d="M27.1736 25.2486C28.5736 26.0611 28.5986 27.3736 27.1861 28.186C25.7987 28.9985 23.5237 28.986 22.1238 28.186C20.7113 27.3736 20.7113 26.0611 22.0988 25.2486C23.5112 24.4236 25.7612 24.4236 27.1736 25.2486Z"
                          fill="#8ABA55"
                        />
                        <path
                          d="M57.8982 42.9861C59.2982 43.7986 59.3232 45.1111 57.9107 45.9235C56.5233 46.736 54.2483 46.7235 52.8484 45.9235C51.4359 45.1111 51.4359 43.7986 52.8234 42.9861C54.2358 42.1611 56.4858 42.1736 57.8982 42.9861Z"
                          fill="#8ABA55"
                        />
                        <path
                          d="M70.6364 41.0492C68.4239 42.3366 68.4364 44.4241 70.6614 45.7115L57.5992 53.2988C55.3743 52.0114 51.7619 52.0114 49.5494 53.2988L9.38804 30.112C11.6005 28.8245 11.588 26.7371 9.36304 25.4496L22.4252 17.8623C24.6501 19.1498 28.2625 19.1498 30.475 17.8623L70.6364 41.0492ZM31.0249 40.7992C34.9998 43.0991 42.2621 42.6241 47.2245 39.7367C52.1994 36.8493 52.9618 32.6494 48.9995 30.3495C45.0121 28.0495 37.7873 28.5245 32.8124 31.4119C27.85 34.2994 27.0376 38.4992 31.0249 40.7992ZM52.8494 45.9115C54.2493 46.724 56.5243 46.724 57.9117 45.9115C59.3242 45.0865 59.2992 43.7741 57.8992 42.9741C56.4868 42.1616 54.2368 42.1491 52.8243 42.9741C51.4369 43.7866 51.4369 45.0991 52.8494 45.9115ZM22.1252 28.1745C23.5252 28.987 25.8001 28.987 27.1876 28.1745C28.6 27.3495 28.575 26.0371 27.1751 25.2371C25.7626 24.4246 23.5127 24.4121 22.1002 25.2371C20.7127 26.0496 20.7127 27.362 22.1252 28.1745Z"
                          fill="#98CB66"
                        />
                        <path
                          d="M48.9863 30.3629C52.9612 32.6628 52.1862 36.8627 47.2113 39.7501C42.2489 42.6375 34.9866 43.1 31.0118 40.8126C27.0244 38.5126 27.8368 34.3127 32.7992 31.4253C37.7741 28.5254 45.0114 28.0629 48.9863 30.3629Z"
                          fill="#8ABA55"
                        />
                        <path
                          d="M57.5573 30.0116L30.3581 45.7112L22.4458 41.1363L49.6451 25.4492L57.5573 30.0116Z"
                          fill="#FFCC66"
                        />
                        <path
                          d="M30.3085 45.686L30.296 54.9607L22.3462 50.3859L22.3587 41.0986L30.3085 45.686Z"
                          fill="#F2BB56"
                        />
                        <path
                          d="M79.9978 30.949L79.9728 40.2362C79.9728 40.4987 79.7978 40.7487 79.4603 40.9487L54.8235 55.2608C54.136 55.6608 53.0235 55.6608 52.3486 55.2608L30.2992 42.5237L22.3494 37.9363L0.524986 25.3491C0.187495 25.1491 0 24.8741 0 24.6242L0.0249993 15.3369C0.0249993 15.5994 0.199995 15.8494 0.549985 16.0619L22.3494 28.649L30.2992 33.2364L52.3736 45.9736C53.061 46.3736 54.1735 46.3736 54.8485 45.9736L79.4853 31.6615C79.8228 31.4615 79.9978 31.199 79.9978 30.949Z"
                          fill="#7CA444"
                        />
                        <path
                          d="M79.4858 31.6616L54.849 45.9737C54.1615 46.3737 53.0491 46.3737 52.3741 45.9737L30.3747 33.2741L22.4499 28.6992L0.550485 16.0621C-0.149496 15.6621 -0.149497 15.0246 0.537985 14.6246L25.1748 0.299992C25.8623 -0.0999972 26.9748 -0.0999972 27.6497 0.299992L49.6492 12.9996L57.5739 17.5745L79.4733 30.2242C80.1733 30.6242 80.1733 31.2616 79.4858 31.6616Z"
                          fill="#8ABA55"
                        />
                        <path
                          d="M27.1736 12.7998C28.5736 13.6123 28.5986 14.9247 27.1861 15.7372C25.7987 16.5497 23.5237 16.5372 22.1238 15.7372C20.7113 14.9247 20.7113 13.6123 22.0988 12.7998C23.5112 11.9873 25.7612 11.9873 27.1736 12.7998Z"
                          fill="#8ABA55"
                        />
                        <path
                          d="M57.8982 30.5361C59.2982 31.3486 59.3232 32.6611 57.9107 33.4735C56.5233 34.286 54.2483 34.2735 52.8484 33.4735C51.4359 32.6611 51.4359 31.3486 52.8234 30.5361C54.2358 29.7236 56.4858 29.7236 57.8982 30.5361Z"
                          fill="#8ABA55"
                        />
                        <path
                          d="M70.6364 28.6001C68.4239 29.8876 68.4364 31.9751 70.6614 33.2625L57.5992 40.8498C55.3743 39.5623 51.7619 39.5623 49.5494 40.8498L9.38804 17.6754C11.6005 16.388 11.588 14.3005 9.36304 13.0131L22.4252 5.42578C24.6501 6.71325 28.2625 6.71325 30.475 5.42578L70.6364 28.6001ZM31.0249 28.3626C34.9998 30.6626 42.2621 30.1876 47.2245 27.3002C52.1994 24.4128 52.9618 20.2129 48.9995 17.9129C45.0121 15.613 37.7873 16.088 32.8124 18.9754C27.85 21.8628 27.0376 26.0627 31.0249 28.3626ZM52.8494 33.475C54.2493 34.2875 56.5243 34.2875 57.9117 33.475C59.3242 32.65 59.2992 31.3376 57.8992 30.5376C56.4868 29.7251 54.2368 29.7126 52.8243 30.5376C51.4369 31.3501 51.4369 32.6625 52.8494 33.475ZM22.1252 15.738C23.5252 16.5505 25.8001 16.5505 27.1876 15.738C28.6 14.913 28.575 13.6006 27.1751 12.8006C25.7626 11.9881 23.5127 11.9756 22.1002 12.8006C20.7127 13.6131 20.7127 14.9255 22.1252 15.738Z"
                          fill="#98CB66"
                        />
                        <path
                          d="M48.9863 17.9117C52.9612 20.2116 52.1862 24.4115 47.2113 27.2989C42.2489 30.1863 34.9866 30.6488 31.0118 28.3614C27.0244 26.0615 27.8368 21.8616 32.7992 18.9741C37.7741 16.0867 45.0114 15.6117 48.9863 17.9117Z"
                          fill="#8ABA55"
                        />
                        <path
                          d="M57.5573 17.5739L30.3581 33.2735L22.4458 28.6986L49.6451 12.999L57.5573 17.5739Z"
                          fill="#FFCC66"
                        />
                        <path
                          d="M30.3085 33.2358L30.296 42.5231L22.3462 37.9357L22.3587 28.6484L30.3085 33.2358Z"
                          fill="#F2BB56"
                        />
                      </svg>
                    </div>
                  </div>
                </Col>
                {/* <Col lg="6" className="my-2">
                  <h5 className="m-0 pb-2 fw-sbold themeBlue">Document</h5>{" "}
                  <Slider {...settings}>
                    {agencyDetail?.documentsList?.map((item) => {
                      const { image } = item;
                      return (
                        <div className="cardCcstm text-center d-flex align-items-center justify-content-around border rounded p-3 gap-10 flex-auto">
                          <div className="imgWrp">
                            <img
                              src={image || d1}
                              alt=""
                              className="img-fluid object-fit-contain"
                              style={{ height: 100 }}
                            />
                          </div>
                          <div className="content">
                            <p className="text-muted fw-sbold m-0">
                              EIN Number:
                            </p>
                            <p className="text-danger fw-sbold m-0">
                              {item?.number || "34234234234"}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </Col> */}
                <Col lg="6" className="my-2">
                  <h5 className="m-0 pb-2 fw-sbold themeBlue">Document</h5>{" "}
                  <Slider {...settings}>
                    {agencyDetail?.documentsList?.map((item) => {
                      const { image } = item;
                      return (
                        <div className="cardCcstm text-center d-flex align-items-center justify-content-around border rounded p-3 gap-10 flex-auto">
                          <div className="imgWrp">
                            <img
                              src={image || d1}
                              alt="document"
                              className="img-fluid object-fit-contain"
                              style={{ height: 100, cursor: "pointer" }}
                              onClick={() => handleImageClick(image || d1)}
                            />
                          </div>
                          <div className="content">
                            <p className="text-muted fw-sbold m-0">
                              EIN Number:
                            </p>
                            <p className="text-danger fw-sbold m-0">
                              {item?.number || "34234234234"}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </Col>

                {/* Modal for Image Preview */}
                <Modal show={showModal} onHide={handleClose} centered>
                  <Modal.Header closeButton>
                    {/* <Modal.Title>Document Preview</Modal.Title> */}
                  </Modal.Header>
                  <Modal.Body className="text-center">
                    {selectedImage && (
                      <img
                        src={selectedImage}
                        alt="Document Preview"
                        className="img-fluid"
                        style={{ maxHeight: "500px" }}
                      />
                    )}
                  </Modal.Body>
                </Modal>
                <Col md="12" className="my-2">
                  <h5 className="m-0 mt-4 pb-2 fw-sbold themeBlue">
                    Bank Details of Agency:
                  </h5>
                  <div className="cardCstm border rounded px-3 py-2">
                    <div className="table-responsive">
                      <table className="table m-0">
                        <thead>
                          <tr>
                            <th className="text-muted text-start">
                              Bank Name:
                            </th>
                            <th className="text-muted text-start ">
                              Routing number:
                            </th>
                            <th className="text-muted text-start">
                              Account number:
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-start text-danger border-0 fw-bold">
                              {agencyDetail?.bankDetails?.bankName}
                            </td>
                            <td className="text-start text-danger border-0 fw-bold">
                              {agencyDetail?.bankDetails?.routingNumber}
                            </td>
                            <td className="text-start text-danger border-0 fw-bold">
                              {agencyDetail?.bankDetails?.accountNumber}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg="12" className="my-2 mt-4">
              <h5 className="m-0 pb-2 fw-sbold themeBlue">Agency Driver:</h5>
              <div className="table-responsive">
                <Table data={agencyDetail?.drivers} column={col} />
              </div>
            </Col>
            <Col lg="12" className="my-2 mt-4">
              <h5 className="m-0 pb-2 fw-sbold themeBlue">Booking Details:</h5>
              <div className="table-responsive">
                <Table data={agencyDetail?.bookings} column={column} />
                  {/* 
                <div className="d-flex justify-content-end">
                  <CustomPagination
                    current={body.page}
                    pageSize={body.limit}
                    total={agenciesDataTotal}
                    pageChangeHandler={pageChangeHandler}
                  />
                </div> */}
                {/* {agencyDetail?.bookings?.length > 0 && (
                  <div className="d-flex justify-content-end mt-3">
                    <CstmPagination
                      data={agencyDetail?.bookings}
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                    />
                  </div>
                )} */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AgencyDetail;
